import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getReport = createAsyncThunk(
  "student/report",
  async ({ qaId, contestId }, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `/report?qaFilter=${qaId}&contestFilter=${contestId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addReport = createAsyncThunk(
  "admin/addReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/result-report/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getRanks = createAsyncThunk(
  "student/rank",
  async ({ qaId, contestId }, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `/qa/contest/ranks?qaFilter=${qaId}&contestFilter=${contestId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getQuestionById = createAsyncThunk(
  "question/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/question/${id}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {}
  }
);
export const getQuestionByAiMentor = createAsyncThunk(
  "question/ai-mentor",
  async (id) => {
    try {
      const response = await apiInstance.get(
        `/question/ai-mentor?questionId=${id}`,
        {
          headers: authHeader(),
          skipErrorToast: true,
        }
      );
      return response;
    } catch (error) {}
  }
);

const initialState = {
  classesData: [],
  rankData: [],
};

const reportSlice = createSlice({
  name: "reportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReport.fulfilled, (state, action) => {
      state.reportData = action.payload.data;
    });
    builder.addCase(getRanks.fulfilled, (state, action) => {
      state.rankData = action.payload.data;
    });
  },
});
export default reportSlice.reducer;
